import useAZZKUTopics from "hooks/AZZKU/useAZZKUTopics";

import CheckboxGroup from "components/CheckboxGroup";
import ExpandableBox from "components/ExpandableBox";
import Options from "components/Options";
import Loader from "components/Loader";

export default function Step1({ params, errors, onChange }) {

   const { d: topics } = useAZZKUTopics( true );

   return topics ? (
      <>
         <p> Wybierz kategorię, a następnie wskaż dane, które chcesz zobaczyć w tabeli. </p>

         <ExpandableBox heading="Kategoria danych">

            <CheckboxGroup
               name="topics"
               value={ params.topics || []}
               style={{ gap: "10px 36px" }}
               item_style={{ flex: "unset" }}
               buttons={ topics || []}
               onChange={( n, v ) => onChange({
                  [ n ]: v,
                  variable_id: undefined
               })}
            />

            { params.topics && !!params.topics?.length &&
               params.topics.map(( topic_id ) => {

                  const topic = topics.find( t => t.value === topic_id );

                  return (
                     <ExpandableBox
                        key={ topic_id }
                        heading={ topic.label }
                        extra_classes="inner"
                     >
                        <Options
                           name={ "variable_id_" + topic_id }
                           value={ params.variable_id }
                           options={ topic?.variables }
                           onChange={( n, v ) => onChange({
                              variable_id: v
                           })}
                        />
                     </ExpandableBox>
                  )
               })
            }

            {( errors.topics || errors.variable_id ) &&
               <div className="error">
                  { errors.topics || errors.variable_id }
               </div>
            }
         </ExpandableBox>
      </>
   ) : <Loader/>
}